export default "__VITE_ASSET__BRu$KhoZ__"